import { InputNumber } from "antd";

export const NumberInput = ({
  onChange,
  name,
  value,
  ...props
}: {
  onChange: any;
  name: any;
  value: any;
}) => {
  return (
    <InputNumber
      min={0}
      className="x100"
      inputMode="numeric"
      value={value}
      formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
      parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
      onChange={(value) => {
        const event = {
          target: { name, value },
        };
        onChange(event);
      }}
      {...props}
    />
  );
};
